"use client";

import { Star } from "lucide-react";
import { useTranslation } from "react-i18next";

const Testimonials = () => {
  const { t } = useTranslation();

  const testimonials = [
    {
      name: "Ramond",
      role: t("testimonials.ramond.role"),
      rating: 5,
      text: t("testimonials.ramond.text"),
      avatar: "R",
    },
    {
      name: "Dr. Armstrong",
      role: t("testimonials.armstrong.role"),
      rating: 5,
      text: t("testimonials.armstrong.text"),
      avatar: "DA",
    },
  ];

  return (
    <section className="bg-surface-light py-20 px-6 lg:px-16">
      <div className="max-w-[1100px] mx-auto">
        {/* Section Header */}
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl lg:text-[36px] text-foreground">
            {t("testimonials.heading")}
          </h2>
        </div>

        {/* Testimonial Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {testimonials.map((testimonial) => (
            <div key={testimonial.name} className="flex flex-col">
              <div className="bg-surface-card rounded-xl p-6 shadow-sm flex-1">
                <div className="flex gap-1 mb-3">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star
                      key={i}
                      className="w-4 h-4 text-accent-blue fill-accent-blue"
                    />
                  ))}
                </div>
                <p className="font-body text-sm text-foreground/80 leading-relaxed">
                  "{testimonial.text}"
                </p>
              </div>
              <div className="flex items-center gap-3 mt-4 px-2">
                <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center">
                  <span className="font-heading font-bold text-xs text-white">
                    {testimonial.avatar}
                  </span>
                </div>
                <div>
                  <p className="font-heading font-medium text-sm text-foreground">
                    {testimonial.name}
                  </p>
                  <p className="font-body text-xs text-foreground/60">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
